import React from 'react';
import AboutContentData from '../component/AboutContentData.js';

const About = () => {
    return (
        <section style={{ backgroundColor: '#ffffff', padding: '100px 0' }}>
            <div className="auto-container">
                <div className="row align-items-center clearfix">
                    <div className="col-lg-5 col-md-12 col-sm-12 image-column">
                        <div style={{ position: 'relative', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 20px 40px rgba(0,0,0,0.1)' }}>
                            <img 
                                src={AboutContentData[1]?.serviceImg || '/assets/images/resource/about-1.jpg'} 
                                alt="Imperial Lettings" 
                                style={{ width: '100%', display: 'block' }}
                            />
                            <div style={{ position: 'absolute', bottom: 0, left: 0, padding: '30px', backgroundColor: 'rgba(10, 61, 98, 0.95)', width: '100%' }}>
                                <h2 style={{ color: '#ffffff', fontSize: '3rem', margin: 0, lineHeight: 1 }}>
                                    15+ <span style={{ fontSize: '1.2rem', fontWeight: '400', display: 'block', marginTop: '10px', color: '#25b579' }}>Years of Experience</span>
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-sm-12 content-column">
                        <div style={{ paddingLeft: '40px' }} className="about-content">
                            <h5 style={{ color: '#25b579', fontWeight: '700', fontSize: '14px', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '15px' }}>
                                ABOUT US
                            </h5>
                            <h2 style={{ color: '#0a3d62', fontSize: 'clamp(2.5rem, 4vw, 3rem)', fontWeight: '300', marginBottom: '30px', lineHeight: '1.2' }}>
                                A modern approach to <br/><strong style={{ fontWeight: '700' }}>Property Management</strong>
                            </h2>
                            <p style={{ color: '#555555', fontSize: '1.15rem', lineHeight: '1.8', marginBottom: '30px' }}>
                                {AboutContentData[0]?.longDesc || 'At Imperial Lettings (North East) Limited, providing a professional and efficient service is our top priority. Our team is dedicated to providing prompt, friendly and professional services at all times because they have been trained to the highest standards.'}
                            </p>
                            {window.location.pathname !== '/about' && (
                                <a href="/about" style={{ 
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    backgroundColor: '#0a3d62', 
                                    color: '#ffffff', 
                                    padding: '16px 45px', 
                                    fontWeight: '700', 
                                    fontSize: '1.1rem',
                                    borderRadius: '6px', 
                                    textDecoration: 'none', 
                                    transition: 'all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1)',
                                    boxShadow: '0 10px 20px rgba(10, 61, 98, 0.15)',
                                    position: 'relative',
                                    zIndex: 10
                                }}
                                   onMouseEnter={(e) => {
                                       e.currentTarget.style.background = '#25b579';
                                       e.currentTarget.style.transform = 'translateY(-3px)';
                                       e.currentTarget.style.boxShadow = '0 15px 25px rgba(37, 181, 121, 0.25)';
                                   }}
                                   onMouseLeave={(e) => {
                                       e.currentTarget.style.background = '#0a3d62';
                                       e.currentTarget.style.transform = 'translateY(0)';
                                       e.currentTarget.style.boxShadow = '0 10px 20px rgba(10, 61, 98, 0.15)';
                                   }}
                                >
                                    Read Our Story
                                    <i className="fas fa-arrow-right" style={{ marginLeft: '12px' }}></i>
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
